'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('oem_user_reconfirm', {
    url: '/admin/user_reconfirm',
    template: '<oem-user-reconfirm></oem-user-reconfirm>'
  })
}



// WEBPACK FOOTER //
// ./public/dev/app/oem/oem_user_reconfirm/oem_user_reconfirm.routes.js